import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchUser } from '../../utils/fetchUser';
import { crearDocuGeneralBull, eliminarManDocuMaqFiltro } from "../../services/ManDocuMaq";
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const ListasAsignacion = ({ ListaDatos, mandante, maquina, onChangeDatos }) => {
  const [tasks, setTasks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const User = fetchUser();

  useEffect(() => {
    if (ListaDatos) {
      setTasks(ListaDatos);
    }
  }, [ListaDatos]);

  const handleCheckboxChange = (id) => {
    setTasks((prev) =>
      prev.map((task) =>
        task._id === id
          ? { ...task, state: task.state === 'Finalizadas' ? 'Pendientes' : 'Finalizadas' }
          : task
      )
    );
  };

  const handleApplyChanges = async () => {
    try {
      if (!mandante) {
        toast.warning('Debe seleccionar un mandante antes de aplicar los cambios');
        return;
      }

      if (!maquina) {
        toast.warning('Debe seleccionar una máquina antes de aplicar los cambios');
        return;
      }

      const finalizadasData = tasks
        .filter((task) => task.state === 'Finalizadas')
        .map((task) => ({
          empresa: User.empresa,
          idMandante: mandante,
          idMaquina: maquina,
          idDocuGeneral: task._id,
        }));

      if (finalizadasData.length === 0) {
        await eliminarManDocuMaqFiltro(mandante, maquina);
        toast.success('Cambios aplicados');
        onChangeDatos('REFRESH');
        return;
      }

      await crearDocuGeneralBull(finalizadasData);

      toast.success('Cambios aplicados');
      onChangeDatos('REFRESH');

    } catch (error) {
      console.error('Error al aplicar los cambios:', error);
      toast.error('Error al aplicar los cambios');
    }
  };

  const filteredTasks = tasks.filter((task) =>
    task.documentoGeneral.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-4 bg-gray-50 rounded-lg shadow">
      {/* Barra de búsqueda tipo Google */}
      <div className="flex items-center mb-4">
        <input
          type="text"
          placeholder="Buscar documentos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 p-2 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      {/* Lista de documentos */}
      <div className="space-y-3">
        {filteredTasks.length > 0 ? (
          filteredTasks.map((task) => (
            <div
              key={task._id}
              className="flex items-center bg-white p-3 rounded-lg shadow-sm hover:shadow-md transition"
            >
              <input
                type="checkbox"
                checked={task.state === 'Finalizadas'}
                onChange={() => handleCheckboxChange(task._id)}
                className="mr-3 h-5 w-5 text-blue-500"
              />
              <div className="flex-1">
                <p className="text-sm font-medium">{task.documentoGeneral}</p>
              </div>
              <span style={{
                display: 'inline-block',
                padding: '1px 8px',
                borderRadius: '10px',
                fontSize: '11px',
                fontWeight: '600',
                marginRight: '8px',
                backgroundColor: task.tipo === 'Obra' ? '#FEF3C7' : task.tipo === 'Anexo' ? '#FEE2E2' : '#DBEAFE',
                color: task.tipo === 'Obra' ? '#92400E' : task.tipo === 'Anexo' ? '#991B1B' : '#1E40AF',
              }}>
                {task.tipo || 'Logística'}
              </span>
              {task.state === 'Finalizadas' && (
                <CheckCircleIcon className="h-5 w-5 text-green-500" />
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-sm">No se encontraron documentos.</p>
        )}
      </div>

      {/* Botón aplicar cambios */}
      <div className="mt-4 flex justify-end">
        <button
          onClick={handleApplyChanges}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Aplicar Cambios
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ListasAsignacion;